import { useMutation, useQueryClient } from '@tanstack/react-query'

import { watchlistKeys } from '@/features/watchlist/api/keys'
import { watchlistService } from '@/features/watchlist/api/watchlistService'

export const useSetWatchlistSymbols = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, symbols }: { id: string; symbols: string[] }) =>
      watchlistService.setSymbols(id, symbols),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watchlistKeys.all }),
  })
}

export const useCreateWatchlist = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (name: string) => watchlistService.createList(name),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watchlistKeys.all }),
  })
}

/** Puts one name on one list, then refreshes every watchlist read (the rail, Home, the sidebar). */
export const useAddWatchlistSymbol = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, symbol }: { id: string; symbol: string }) =>
      watchlistService.addSymbol(id, symbol),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watchlistKeys.all }),
  })
}

/** Takes one name off one list, then refreshes every watchlist read (the rail, Home, the sidebar). */
export const useRemoveWatchlistSymbol = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, symbol }: { id: string; symbol: string }) =>
      watchlistService.removeSymbol(id, symbol),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watchlistKeys.all }),
  })
}
